import React, { useMemo } from "react";

import { IUserSocialSecurityForm } from "Bands/types";
import { TeaserProps } from "shared/components";
import { DocumentTeaser } from "./DocumentTeaser";

interface Props extends IUserSocialSecurityForm, TeaserProps {}

export const SocialSecurityFormTeaser: React.FC<Props> = ({ title, documentType, ...rest }) => {
  const teaserTitle = useMemo(
    () => `${documentType} ${title && `(${title})`} `,
    [documentType, title]
  );

  return <DocumentTeaser {...rest} title={teaserTitle} />;
};
